import { call, put, takeEvery, select } from "redux-saga/effects";
import { donHangApi } from "../../../api/don-hang/donHangApi";
import { IDonHangCreateRequest } from "../../../model/request/ban-hang/IDonHangCreateRequest";
import { IDonHangDoiTraRequest } from "../../../model/request/ban-hang/IDonHangDoiTraRequest";
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { eBanHangActionIds, IBanHangActionPayload, IBanHangActionTypes } from "../../action-types/ban-hang/IBanHangActionType";
import { rootActions } from '../../actions/rootActions';
const mainAction = rootActions.banHang;
export function* donHangSaga(): any {
    yield takeEvery(eBanHangActionIds.CREATE_DONHANG_START, createDonHangWorker)
    yield takeEvery(eBanHangActionIds.LOAD_DON_HANG_START, loadDonHangByHocSinhWorker)
    yield takeEvery(eBanHangActionIds.GET_DETAIL_VIEW_START, getDetailViewWorker)
    yield takeEvery(eBanHangActionIds.HUY_DON_HANG_START, huyDonHangWorker)
    yield takeEvery(eBanHangActionIds.DOI_TRA_DON_HANG_START, doiTraDonHangWorker)
    yield takeEvery(eBanHangActionIds.CAP_NHAT_DA_GIAO_HANG_START, capNhatDaGiaoHangWorker)
}

function* createDonHangWorker(action: IBanHangActionTypes): any {
    const payload = action.payload as IBanHangActionPayload<IDonHangCreateRequest>;

    try {
        const res: IBaseRespone = yield call(donHangApi.Create, payload.data);

        if (res.is_success) {
            const donHangId = res.data;
            const state = yield select();
            const selectedTab = state.banHang.tabs.find((tab: any) => tab.id === payload.tabId);
            const hocSinhId = selectedTab?.hocSinh?.id || 0;

            yield put(mainAction.CREATE_DONHANG_SUCCCESS({
                tabId: payload.tabId,
                data: donHangId
            }))
            yield put(mainAction.GET_DETAIL_VIEW_START({
                tabId: payload.tabId,
                data: donHangId
            }))

            // Reload order history to show the newly created order
            if (hocSinhId > 0) {
                yield put(mainAction.LOAD_DON_HANG_START({
                    tabId: payload.tabId,
                    data: hocSinhId
                }))
            }
        } else {
            yield put(mainAction.CREATE_DONHANG_ERROR({
                tabId: payload.tabId,
                data: res.message ?? "Có lỗi"
            }))
        }
    } catch (error) {
        yield put(mainAction.CREATE_DONHANG_ERROR({
            tabId: payload.tabId,
            data: "Có lỗi xảy ra"
        }))
    }
}

function* loadDonHangByHocSinhWorker(action: IBanHangActionTypes): any {
    const payload = action.payload as IBanHangActionPayload<number>;
    const res: IBaseRespone = yield call(donHangApi.GetByHocSinh, payload.data)
    if (res.is_success) {
        yield put(mainAction.LOAD_DON_HANG_SUCCESS({
            tabId: payload.tabId,
            data: res.data
        }))
    } else {
        yield put(mainAction.LOAD_DON_HANG_ERROR({
            tabId: payload.tabId,
            data: res.message ?? "Có lỗi"
        }))
    }
}

function* getDetailViewWorker(action: IBanHangActionTypes): any {
    const payload = action.payload as IBanHangActionPayload<number>;
    const id = payload.data;
    const tabId = payload.tabId;

    try {
        const res: IBaseRespone = yield call(donHangApi.SelectViewDetail, id);
        if (res.is_success) {
            // Make sure the data is in the correct format for IDonHangViewDetailResponse
            yield put(mainAction.GET_DETAIL_VIEW_SUCCESS({
                tabId: tabId,
                data: res.data
            }));
        } else {
            yield put(mainAction.GET_DETAIL_VIEW_ERROR({
                tabId: tabId,
                data: res.message ?? "Có lỗi"
            }));
        }
    } catch (error: any) {
        yield put(mainAction.GET_DETAIL_VIEW_ERROR({
            tabId: tabId,
            data: error.message ?? "Có lỗi"
        }));
    }
}

function* huyDonHangWorker(action: IBanHangActionTypes): any {
    const payload = action.payload as IBanHangActionPayload<{ id: number, ly_do_huy: string }>;
    const state = yield select();
    const selectedTab = state.banHang.tabs.find((tab: any) => tab.id === payload.tabId);
    const hocSinhId = selectedTab?.hocSinh?.id || 0;
    const uf_kho_id = parseInt(localStorage.getItem("uf_kho_id") ?? "0") ?? 0;
    const dm_coso_id = parseInt(localStorage.getItem("dm_coso_id") ?? "0") ?? 0;

    const res: IBaseRespone = yield call(donHangApi.HuyDonHang, payload.data)
    if (res.is_success) {
        yield put(mainAction.HUY_DON_HANG_SUCCCESS({
            tabId: payload.tabId,
            data: res.data
        }))

        // Reset order data like create new order
        yield put(mainAction.CHANGE_SELECTED_ID(0))
        if (selectedTab) {
            yield put(mainAction.UPDATE_TAB_DATA({
                ...selectedTab,
                donHangId: 0,
                donHangViewDetail: undefined,
                isShowPrint: false,
                isViewingOrderDetails: false, // Reset flag khi hủy đơn hàng
                request: {
                    id: 0,
                    uf_kho_id: uf_kho_id,
                    dm_coso_id: dm_coso_id,
                    ts_hocsinh_id: hocSinhId,
                    items: [],
                    thanhToans: [],
                    ma_don_hang_doi_tra: "",
                },
            }))
        }

        // Automatically show history after update
        yield put(mainAction.CHANGE_SHOW_HISTORY(true))

        // Reload data after successful update
        if (hocSinhId > 0) {
            yield put(mainAction.LOAD_DON_HANG_START({
                tabId: payload.tabId,
                data: hocSinhId
            }))
        }
    } else {
        yield put(mainAction.HUY_DON_HANG_ERROR({
            tabId: payload.tabId,
            data: res.message ?? "Có lỗi"
        }))
    }
}

function* doiTraDonHangWorker(action: IBanHangActionTypes): any {
    const payload = action.payload as IBanHangActionPayload<IDonHangDoiTraRequest>;
    const state = yield select();
    const selectedTab = state.banHang.tabs.find((tab: any) => tab.id === payload.tabId);
    const hocSinhId = selectedTab?.hocSinh?.id || 0;

    const res: IBaseRespone = yield call(donHangApi.DoiTraDonHang, payload.data)
    if (res.is_success) {
        yield put(mainAction.DOI_TRA_DON_HANG_SUCCCESS({
            tabId: payload.tabId,
            data: res.data
        }))

        // Automatically show history after update
        yield put(mainAction.CHANGE_SHOW_HISTORY(true))

        // Reload data after successful update
        if (hocSinhId > 0) {
            yield put(mainAction.LOAD_DON_HANG_START({
                tabId: payload.tabId,
                data: hocSinhId
            }))
        }
    } else {
        yield put(mainAction.DOI_TRA_DON_HANG_ERROR({
            tabId: payload.tabId,
            data: res.message ?? "Có lỗi"
        }))
    }
}

function* capNhatDaGiaoHangWorker(action: IBanHangActionTypes): any {
    const payload = action.payload as IBanHangActionPayload<{ id: number }>;
    const id = payload.data.id;
    const state = yield select();
    const selectedTab = state.banHang.tabs.find((tab: any) => tab.id === payload.tabId);
    const hocSinhId = selectedTab?.hocSinh?.id || 0;

    const res: IBaseRespone = yield call(donHangApi.CapNhatDaGiaoHang, id)
    if (res.is_success) {
        yield put(mainAction.CAP_NHAT_DA_GIAO_HANG_SUCCCESS({
            tabId: payload.tabId,
            data: res.data
        }))
        yield put(mainAction.CHANGE_SHOW_CAP_NHAT_DA_GIAO_HANG(false))

        // Automatically show history after update
        yield put(mainAction.CHANGE_SHOW_HISTORY(true))

        // Reload data after successful update
        if (hocSinhId > 0) {
            yield put(mainAction.LOAD_DON_HANG_START({
                tabId: payload.tabId,
                data: hocSinhId
            }))
        }
    } else {
        yield put(mainAction.CAP_NHAT_DA_GIAO_HANG_ERROR({
            tabId: payload.tabId,
            data: res.message ?? "Có lỗi"
        }))
    }
}
